<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
import { mapState } from "vuex";
import wlArticle from "@/components/wl-article";
export default {
  components: { wlArticle },
  data() {
    return {
      load: false,

      showBanner: false,
      banner: [],

      navFix: 0, //0-首页 -1-关注 >1-其他领域
      lyNav: [], //领域列表
      topicData: [],  //专题
      expertColumn: [], //专家推荐

      articleRefreshLoading: false, //刷新
      articleLoading: false, //加载
      articleFinished: false, //加载完成
      articleList: [],
      pagination: {
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "authToken"]),
  },
  watch: {},
  created: function () {},
  mounted: function () {
    //登陆成功跳转关注标签
    var navFix = Number(this.$route.params.nav);
    if (navFix === -1) {
      this.navFix = navFix;
    }else{
      if(this.authToken){
        this.navFix = -1;
      }
    }
    this.initData();
  },
  methods: {    
    //初始化数据层
    async initData() {
      this.load = false;
      await this.$api.domainPage().then((res) => {
        this.lyNav = res.data.data || [];
      });
      //获取专题
      // this.$api.topicList().then(res=>{
      //   console.log(res);
      //   this.topicData = res.data
      // })
      //获取广告
      this.$api
        .bannerPage({
          condition: {
            stc: "1",
            items: [{ code: "home", opc: "=", values: [1] }],
          },
        })
        .then((res) => {
          console.log(res);
          this.banner = res.data.data || [];
        });
      this.load = true;
    },

    //切换领域
    changeNav(nav) {
      this.navFix = nav;
      this.articleLoading = true;
      this.pagination.index = 0;
      this.articleList = [];
      this.loadArticle();
    },

    //详情
    toExpectInfo(item){
      if(this.navFix===-1){
        this.$glf.goUrl('push','/expert_info/'+item.id)
      }else{
        this.$glf.goUrl('push','/expert_info/'+item.userId)
      }
    },

    //用户关注医生列表
    userGzList() {
      var params = {
        pagination: {
          index: 1,
          size: 10,
        },
      };
      this.$api.userFavPage(params).then((res) => {
        this.expertColumn = res.data.data || [];
      });
    },
    //获取领域下的医生列表
    getLyList() {
      var params = {
        condition: {
          stc: "1",
          items: [{ code: "domainId", opc: "=", values: [this.navFix] }],
        },
        sort: [{ code: "sn", desc: false }],
        pagination: {
          index: 1,
          size: 10,
        },
      };
      this.$api.domainConfigPage(params).then((res) => {
        this.expertColumn = res.data.data || [];
      });
    },

    //刷新文章
    refreshArticle() {
      this.articleFinished = false;
      this.pagination.index = 0;
      this.loadArticle().then((res) => {
        this.articleRefreshLoading = false;
      });
    },
    //加载文章
    loadArticle() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index + 1,
          size: this.pagination.size,
        },
        sort: [{ code: "publishDtm", desc: true }],
      };
      if (this.navFix > 0) {
        params.condition = {
          stc: "1",
          items: [{ code: "domainId", opc: "=", values: [this.navFix] }],
        };
        //获取领域下的推荐的医生
        this.getLyList();
        this.showBanner = false;
      }
      if (this.navFix === -1) {
        params.condition = {
          stc: "1",
          items: [
            { code: "domainId", opc: "=", values: [this.userInfo.domainId] },
          ],
        };
        //获取关注的医生
        this.userGzList();
        this.showBanner = true;
      }
      if (this.navFix === 0) {
        this.showBanner = true;
        this.expertColumn = [];
      }
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.$api.articlePage(params).then((res) => {
          var data = res.data;
          var list = data.data || [];
          list.map((r) => {
            if (r.imgs) {
              r.imgs = JSON.parse(r.imgs);
            } else {
              r.imgs = [];
            }
            return r;
          });
          if (data.pagination.index === 1) {
            _this.articleList = list;
          } else {
            _this.articleList = _this.articleList.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.articleList.length >= _this.pagination.total) {
            _this.articleFinished = true;
          }
          // 加载状态结束
          _this.articleLoading = false;
          resolve();
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/master/index.vue